import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal
} from "@angular/core";

import {
  AppSharedMenuComponent,
  LektoAuthService,
  ProfileConstants
} from "@frontends-v3/shared-core";
import { NavbarMenuItemType } from "@frontends-v3/design-system";

import { environment } from "../../../../environments/environment";
import { buildPlatformNavItems } from "../nav-items";

@Component({
  selector: "app-menu",
  imports: [AppSharedMenuComponent],
  templateUrl: "./menu.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent {
  public readonly isCollapsed = input<boolean>(false);
  public readonly toggleSidebar = output<void>();

  public readonly appVersion = signal<string>(environment.version.split(".").slice(0, 2).join("."));

  private readonly authService = inject(LektoAuthService);

  public readonly menuItems = computed<NavbarMenuItemType[]>(() =>
    buildPlatformNavItems(ProfileConstants.isReaderProfile(this.authService.authProfile()))
  );

  public onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }
}
